module.exports = __webpack_public_path__ + "img/capa-padrao-tecnologia.757fa88e.png";